import * as core from '../../../../../../../core'

import { query } from './override-risk-level.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.subaward-details.widgets.override-risk-level',
    description: 'Override Risk Level',
    name: 'Override Risk Level',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
